// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
import '@lib/scss/base.lib.scss';

// import libs
import 'img-comparison-slider/dist/index';
import 'jquery.toc/jquery.toc';

// require main js file
require('@js/index');
require('@js/header');
require('@js/accordion');
require('@js/footer');
require('@js/swiper');
require('@js/video-bg');
require('@js/animations');
require('@js/select');
require('@js/map');
require('@js/scrolling-accordion');
require('@js/scrolling-block');
require('@js/ajax-post');
require('@js/ajax-press');
require('@js/table');
